import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { UsuariosService } from '@usuarios/pages/usuarios-page/services';

@Pipe({ name: 'usuarioNombre' })
export class UsuarioNombrePipe implements PipeTransform {
  constructor(private readonly usuariosService: UsuariosService) {}

  transform(id: number | null | undefined): Observable<string> {
    if (!id) return of('');
    return this.usuariosService
      .getUsuariosSimple()
      .pipe(map((list) => list.find((u) => u.personaId === id)?.razonSocial ?? id.toString()));
  }
}
